import React from 'react'

import { Control } from 'react-hook-form/dist/types/form'

import { IconUser } from '../../../icons/IconUser'
import { IconUserName } from '../../../icons/IconUserName'
import { IconEmailImg } from '../../../icons/IconEmailImg'
import { IconDate } from '../../../icons/IconDate'
import { NationalityIconImg } from '../../../icons/NationalityIconImg'
import { IconHorseImg } from '../../../icons/IconHorseImg'
import { IconBreadImg } from '../../../icons/IconBreadImg'
import { IconGenderImg } from '../../../icons/IconGenderImg'
import { IconColoringImg } from '../../../icons/IconColoringImg'
import { IconPhone } from '../../../icons/IconPhone'
import { IconPassword } from '../../../icons/IconPassword'
import { IInputField } from '../../../modals/components/InputRow'

import { IRiderSignupForm } from '../../../../types/competitor_types'

import { CountryList } from '../../../../fakeData/countryList'
import { disciplineData } from '../../../../fakeData/disciplineList'
import { horseBreedList } from '../../../../fakeData/horseBreedList'
import { SexRestOptions } from '../../../customStyles/ReactSelectCustomStyle'
import { horseColorList } from '../../../../fakeData/horseColorList'

export const initialUserInputs = {
  userFullName: {
    name: 'userFullName',
    value: '',
    required: true,
    placeholder: 'Enter full name...',
    type: 'text',
    label: 'Full Name',
  },
  userName: {
    name: 'userName',
    value: '',
    required: true,
    placeholder: 'Enter user name...',
    type: 'text',
    label: 'User Name',
  },
  email: {
    name: 'email',
    value: '',
    required: true,
    placeholder: 'Enter address...',
    type: 'email',
    label: 'Email address',
  },
  date: {
    name: 'date',
    value: '',
    required: true,
    placeholder: 'Select date...',
    type: 'date',
    label: 'Date of birth',
  },
  nationality: {
    name: 'nationality',
    value: '',
    required: false,
    placeholder: 'Select nationality...',
    type: 'select',
    label: 'Nationality',
    selectData: CountryList,
  },
  discipline: {
    name: 'discipline',
    value: '',
    required: false,
    placeholder: 'Select discipline....',
    type: 'select',
    label: 'Discipline',
    selectData: disciplineData,
  },
}

export const inputUserIcons = {
  userFullName: <IconUser />,
  userName: <IconUserName />,
  email: <IconEmailImg />,
  date: <IconDate />,
  nationality: <NationalityIconImg />,
  discipline: <IconHorseImg />,
}

export const initialHorseInputs = {
  name: {
    name: 'name',
    value: '',
    required: true,
    placeholder: 'Enter name...',
    type: 'text',
    label: 'Name',
  },
  breed: {
    name: 'breed',
    value: '',
    required: true,
    placeholder: 'Select breed...',
    type: 'select',
    label: 'Breed',
    selectData: horseBreedList,
  },
  gender: {
    name: 'gender',
    value: '',
    required: true,
    placeholder: 'Select gender...',
    type: 'select',
    label: 'Gender',
    selectData: SexRestOptions,
  },
  coloring: {
    name: 'coloring',
    value: '',
    required: true,
    placeholder: 'Select coloring...',
    type: 'select',
    label: 'Coloring',
    selectData: horseColorList,
  },
}

export const inputHorseIcons = {
  name: <IconHorseImg />,
  breed: <IconBreadImg />,
  gender: <IconGenderImg />,
  coloring: <IconColoringImg />,
}

export const createRiderProfileInputFields = (control: Control<IRiderSignupForm>) => {
  return [
    { label: 'Full Name', required: true, icon: <IconUser />, name: 'fullName', type: 'text' },
    {
      label: 'User Name',
      required: true,
      icon: <IconUserName />,
      name: 'userName',
      type: 'text',
    },
    {
      label: 'Email Address',
      required: true,
      icon: <IconEmailImg />,
      name: 'email',
      type: 'email',
    },
    {
      label: 'Phone Number',
      required: true,
      icon: <IconPhone />,
      name: 'userPhoneNumber',
      type: 'phone',
    },
    {
      label: 'Password',
      required: true,
      icon: <IconPassword />,
      name: 'password',
      type: 'password',
    },
    {
      label: 'Confirm Password',
      required: true,
      icon: <IconPassword />,
      name: 'confirmPassword',
      type: 'password',
    },
    {
      label: 'Date of birth',
      required: true,
      icon: <IconDate />,
      name: 'userDOB',
      type: 'date',
      control: control,
    },
    {
      label: 'Nationality',
      icon: <NationalityIconImg />,
      name: 'userNationality',
      type: 'select',
      selectData: CountryList,
    },
    {
      label: 'Discipline',
      icon: <IconHorseImg />,
      name: 'userDiscipline',
      type: 'select',
      selectData: disciplineData,
    },
  ] as Array<IInputField>
}
